import type { SVGProps } from 'react';
const SvgGameFeeder = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39" {...props}>
    <path
      fillRule="evenodd"
      d="m19.071 23.357 5.786-3.857V6H13.286v13.5zM26.323 22.007l-2.41 1.6L26.785 33h2.893zM11.8 21.988 8.465 33h2.893l2.893-9.373z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgGameFeeder;
